import { useQuery } from '@tanstack/react-query';

import { janeApiV2 } from '@jane/shared/data-access';

export type Tag = { id: number; tag_type: string; value: string };
type TagResponse = { tags: Tag[] };

const fetchTags = async (): Promise<TagResponse> => {
  const url = `/business/tags`;
  const data = await janeApiV2.get<TagResponse>(url);

  return data;
};

export const useTags = () => {
  return useQuery<TagResponse>({
    queryFn: () => fetchTags(),
    queryKey: ['tags'],
    staleTime: Infinity,
    throwOnError: true,
  });
};
